import React, { useState, useEffect } from "react";
import Loader from "../../../Common/Loader/loader";
import { AllOwnerTypeDetails } from "../../../Apis/ownerTypeApi";
import { AllVehicleTypeDetails } from "../../../Apis/vehicleApi";
import {
  getAllZoneWiseReport,
  getAllCircleWiseReportCircle,
} from "../../../Apis/scvReports/reportedSCVApi";
import { getAllOverallScvTrips } from "../../../Apis/scvReports/overallScvTripsApi";
import { Tab, Tabs, TabPanel, TabList } from "react-tabs";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import {
  AllTransferStationTransactions,
  AllTransferStationTotalTransactions,
  AllTransferStationTransactions1,
  GetSCVTripsToTS,
} from "../../../Apis/TransferStationReport/allTransferStationTransactionApi";
import { useLocation, useNavigate } from "react-router-dom";

import {
  AllSecondaryDeploymentReport,
  AllSecondaryDeploymentTotalReport,
} from "../../../Apis/TransferStationReport/secondaryDeploymentTransactionReportApi";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import isGHMC, { formatDateTimeWithoutSec, getCurrentDateTime1 } from "../../../Common/helper/helpar";

const SCVReports = () => {
  // SCVs Overall Trips to TS/SCTP
  const DeployedFromDate = localStorage.getItem("DeployedFromDate");
  const DeployedFromDate1 = localStorage.getItem("DeployedFromDate1");
  const DeployedToDate = localStorage.getItem("DeployedToDate");
  const DeployedToDate1 = localStorage.getItem("DeployedToDate1");
  const DeployedOwnerType = localStorage.getItem("DeployedOwnerType");
  const DeployedVehicleType = localStorage.getItem("vehicleType");
  const CircleVehicleType = localStorage.getItem("circleVehicleType");
  const location = useLocation();
  const navigate = useNavigate();
   const currentDateTime = getCurrentDateTime();
    const currentDateWithStartTime = getStartOfCurrentDate();
  let dataPerPage = 5;
  const [isLoading, setIsLoading] = useState(false);
  const [ownerTypeDetails, setOwnerTypeDetails] = useState([]);
  const [ownerTypeDetailsTrips, setOwnerTypeDetailsTrips] = useState([]);
  const [zonesData, setZonesData] = useState([]);
  const [fromDate, setFromDate] = useState(
    DeployedFromDate || getStartOfCurrentDate()
  );
  const [fromDate1, setFromDate1] = useState(
    DeployedFromDate1 || getStartOfCurrentDate()
  );
  const [toDate, setToDate] = useState(DeployedToDate||getCurrentDateTime());
  const [toDate1, setToDate1] = useState(DeployedToDate1||getCurrentDateTime());
  const [selectedOwnerType, setSelectedOwnerType] = useState(
    DeployedOwnerType || ""
  );
  const [selectedVehicleType, setSelectedVehicleType] = useState(DeployedVehicleType || "");
  const [selectedCircleVehicleType, setSelectedCircleVehicleType] = useState(CircleVehicleType || "");
  const [vehicleTypeOptionsValues, setVehicleTypeOptionsValues] = useState([]);
  const [vehicleTypeDetails, setVehicleTypeDetails] = useState([]);
  const [optionsValues, setOptionsValues] = useState([]);
  const [selectedOwnerTypeTrips, setSelectedOwnerTypeTrips] = useState("");
  const [selectedTab, setSelectedTab] = useState(0);
  const [isOptionsLoading, setIsOptionsLoading] = useState(false);
  const [scvTripsData, setScvTripsData] = useState([]);
  const isProd = isGHMC();

  useEffect(() => {
    const savedTab = localStorage.getItem("TripsselectedTab");
    if (savedTab) {
      setSelectedTab(parseInt(savedTab, 10));
    }
  }, []);

  const handleTabSelect = (index) => {
    setSelectedTab(index);
    localStorage.setItem("TripsselectedTab", index);
  };

  const fetchOwnerTypeData = async () => {
    try {
      const ownerTypeData = await AllOwnerTypeDetails();
      setOwnerTypeDetails(ownerTypeData);
    } catch (error) {
      console.error("Error fetching owner type data:", error);
    }
  };

  useEffect(() => {
    const fetchVehicleTypeData = async () => {
      try {
        const vehicleTypeData = await AllVehicleTypeDetails();
        setVehicleTypeDetails(vehicleTypeData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };

    fetchVehicleTypeData();
  }, []);

  useEffect(() => {
    setVehicleTypeOptionsValues(vehicleTypeDetails.map(vehicleType => ({
      value: vehicleType.vehicleTypeId,
      label: vehicleType.vehicleTypeName,
    })));
  }, [vehicleTypeDetails]);

  const handleVehicleTypeChange = (newValue, actionMeta) => {
    if (actionMeta.action === 'select-option') {
      setSelectedVehicleType(newValue.value);
    } else if (actionMeta.action === 'create-option') {
      const newValueOption = { label: newValue.label, value: newValue.value };
      setSelectedVehicleType(newValue.value);
      // Add logic to update optionsValues with the new option if needed
    } else {
      if (actionMeta.action === 'clear') {
        setSelectedVehicleType(null); // Ensure selectedOwnerType is cleared
      }
    }
  };

  const fetchOwnerTripsTypeData = async () => {
    try {
      const ownerTypeData = await AllOwnerTypeDetails();
      setOwnerTypeDetailsTrips(ownerTypeData);
    } catch (error) {
      console.error("Error fetching owner type data:", error);
    }
  };

  useEffect(() => {
    fetchOwnerTripsTypeData();
    fetchOwnerTypeData();
  }, []);

  useEffect(() => {
    fetchData(); // Fetch data when component mounts with default selected dates
  }, []);

  useEffect(() => {
    // Set initial fromDate and toDate from location state
    if (location.state) {
      const { fromDate: startDate, toDate: endDate } = location.state;
      setFromDate(startDate);
      setToDate(endDate);
    }
  }, [location.state]);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      localStorage.setItem("DeployedFromDate", fromDate);
      localStorage.setItem("DeployedToDate", toDate);
      localStorage.setItem("vehicleType", selectedVehicleType);
      localStorage.setItem("DeployedOwnerType", selectedOwnerType);
      const response = await getAllZoneWiseReport(
        fromDate,
        toDate,
        selectedVehicleType,
        selectedOwnerType
      );
      // const modifiedData = response.data.map((item) => ({
      //   ...item,
      //   zone: item.zoneName, // Save value of zoneName to zone column
      //   reportedAtTssctp: item.reportedAtTS,
      // }));
      setZonesData(response.data);
      // Handle the response data as needed
    } catch (error) {
      console.error("Error fetching zone wise report:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = () => {
    fetchData(fromDate,
      toDate,
      selectedVehicleType,
      selectedOwnerType); // Call fetchData when the search button is clicked
  };
  const handleZoneClick = async (row) => {
    try {
      setIsLoading(true);
      const response = await getAllCircleWiseReportCircle(
        fromDate1,
        toDate1,
        row.zoneId,
        selectedVehicleType,
        selectedOwnerType
      );
      console.log(response)
      localStorage.setItem("zone", row.zoneId);
      navigate("/view-inner-scv-circle-report", { state: {data:response.data,formatFromDate:fromDate,formatToDate:toDate} });
    } catch (error) {
      console.error("Error fetching circle wise report:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleTotalTrip = async (zoneId) => {
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate,
        EndDate: toDate,
        ZoneId: zoneId,
        OwnerTypeId: selectedOwnerType,
        VehicleTypeId: selectedVehicleType
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/deployed-trips-tssctp",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.error("Error fetching circle wise report:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleTotalTripForTotal = async (zoneId) => {
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate,
        EndDate: toDate,
        OwnerTypeId: selectedOwnerType,
        VehicleTypeId: selectedVehicleType
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/deployed-trips-tssctp",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.error("Error fetching circle wise report:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleTotalDeploymentClick = async () => {
    setIsOptionsLoading(true);
    try {
      const response = await AllSecondaryDeploymentTotalReport(
        fromDate,
        toDate,
        selectedOwnerType,
        selectedVehicleType,
        ""
      );
      navigate("/view-deployed-trips", {
        state: { data: response.data, fromDate, toDate },
      });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleDeploymentClick = async (row) => {
    try {
      setIsLoading(true);
      let response;
      if (row.zoneId !== "" && row.circleId === "") {
        response = await AllSecondaryDeploymentReport(
          fromDate,
          toDate,
          row.zoneId,
          row.circleId, // Pass empty string for circleId
          selectedOwnerType,
          "",
          selectedVehicleType,
          ""
        );
      }
      if (row.zoneId !== "" && row.circleId !== "") {
        response = await AllSecondaryDeploymentReport(
          fromDate,
          toDate,
          row.zoneId,
          "", // Pass circleId,
          selectedOwnerType,
          "",
          selectedVehicleType,

          ""
        );
      }
      // Navigate to the desired page and pass the data as state
      navigate("/view-deployed-trips", {
        state: { data: response.data, fromDate, toDate },
      });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // Set initial fromDate and toDate from location state
    if (location.state) {
      const { fromDate: startDate, toDate: endDate } = location.state;
      setFromDate(startDate);
      setToDate(endDate);
    }
  }, [location.state]);

  const scvReportColumns = [
    {
      name: "S.No",
      width: "70px",
      selector: (row) => row["sno"],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
    },
    {
      name: "Zone",

      selector: (row) => row["zoneName"],
      cell: (row) => (
        <span
          style={{ color: `${row.zoneName === "Total" ? "black" : "blue"}`, cursor: "pointer" }}
          onClick={() => row.zoneName != "Total" && handleZoneClick(row)}
        >
          {row["zoneName"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Deployment",
      // width: "140px",
      selector: (row) => row["deployment"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalDeploymentClick();
            } else {
              handleDeploymentClick(row);
            }
          }}
        >
          {row["deployment"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: (
        <>
          Reported At <br />
          TS/SCTP
        </>
      ),
      // width: "8%",
      selector: (row) => row["reportedAtTS"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleReportedAtTsTotalClick();
            } else {
              handleReportedAtTsZoneClick(row);

            }
          }}
        >
          {row["reportedAtTS"]}
        </span>
      ),
      //    sortable: true,
      // width: "120px",
    },
    {
      name: "Total Trips",
      width: "140px",
      selector: (row) => row["totalTrips"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalTripForTotal();
            } else {
              handleTotalTrip(row["zoneId"]);
            }
          }}
        >
          {" "}
          {row["totalTrips"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Trip-1",
      width: "120px",
      selector: (row) => row["oneTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleOneTripTotalClick();
            } else {
              handleOneTripClick(row["zoneId"]);
            }
          }}
        >
          {row["oneTrip"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Trip-2",
      width: "120px",
      selector: (row) => row["twoTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTwoTripTotalClick();
            } else {
              handleTwoTripClick(row["zoneId"]);
            }
          }}
        >
          {row["twoTrip"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Trip-3",
      width: "120px",
      selector: (row) => row["threeTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleThreeTripTotalClick();
            } else {
              handleThreeTripClick(row["zoneId"]);
            }
          }}
        >
          {row["threeTrip"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Trip-4",
      width: "120px",
      selector: (row) => row["fourTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleFourTripTotalClick();
            } else {
              handleFourTripClick(row["zoneId"]);
            }
          }}
        >
          {row["fourTrip"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: ">05 Trip",
      width: "120px",
      selector: (row) => row["moreThanFiveTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleMoreThanFourTripTotalClick();
            } else {
              handleMoreThanFourTripClick(row["zoneId"]);
            }
          }}
        >
          {row["moreThanFiveTrip"]}
        </span>
      ),
      sortable: true,
    },
  ];

  const handleOneTripClick = async (zoneId) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate,
        EndDate: toDate,
        ZoneId: zoneId,
        OwnerTypeId: selectedOwnerType,
        VehicleTypeId: selectedVehicleType,
        TripTypeId: 1
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/view-overall-trips",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOneTripTotalClick = async () => {
    setIsOptionsLoading(true);
    try {
      const param = {
        StartDate: fromDate,
        EndDate: toDate,
        OwnerTypeId: selectedOwnerType,
        VehicleTypeId: selectedVehicleType,
        TripTypeId: 1
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/view-overall-trips",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleTwoTripTotalClick = async () => {
    setIsOptionsLoading(true);
    try {
      const param = {
        StartDate: fromDate,
        EndDate: toDate,
        OwnerTypeId: selectedOwnerType,
        VehicleTypeId: selectedVehicleType,
        TripTypeId: 2
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/view-overall-trips",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleTwoTripClick = async (zoneId) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate,
        EndDate: toDate,
        ZoneId: zoneId,
        OwnerTypeId: selectedOwnerType,
        VehicleTypeId: selectedVehicleType,
        TripTypeId: 2
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/view-overall-trips",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleThreeTripClick = async (zoneId) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate,
        EndDate: toDate,
        ZoneId: zoneId,
        OwnerTypeId: selectedOwnerType,
        VehicleTypeId: selectedVehicleType,
        TripTypeId: 3
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/view-overall-trips",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleThreeTripTotalClick = async () => {
    setIsOptionsLoading(true);
    try {
      const param = {
        StartDate: fromDate,
        EndDate: toDate,
        OwnerTypeId: selectedOwnerType,
        VehicleTypeId: selectedVehicleType,
        TripTypeId: 3
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/view-overall-trips",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleFourTripTotalClick = async () => {
    setIsOptionsLoading(true);
    try {
      // Call a different API for the total of the column
      const param = {
        StartDate: fromDate,
        EndDate: toDate,
        OwnerTypeId: selectedOwnerType,
        VehicleTypeId: selectedVehicleType,
        TripTypeId: 4
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/view-overall-trips",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleFourTripClick = async (zoneId) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate,
        EndDate: toDate,
        ZoneId: zoneId,
        OwnerTypeId: selectedOwnerType,
        VehicleTypeId: selectedVehicleType,
        TripTypeId: 4
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/view-overall-trips",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleMoreThanFourTripClick = async (zoneId) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate,
        EndDate: toDate,
        ZoneId: zoneId,
        OwnerTypeId: selectedOwnerType,
        VehicleTypeId: selectedVehicleType,
        TripTypeId: 5
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/view-overall-trips",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleMoreThanFourTripTotalClick = async () => {
    setIsOptionsLoading(true);
    try {
      // Call a different API for the total of the column
      const param = {
        StartDate: fromDate,
        EndDate: toDate,
        OwnerTypeId: selectedOwnerType,
        VehicleTypeId: selectedVehicleType,
        TripTypeId: 5
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/view-overall-trips",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  localStorage.setItem("fromDate", fromDate);
  localStorage.setItem("toDate", toDate);

  const option = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTimes = ` ${new Date()
    .toLocaleString("en-GB", option)
    .replace(/\//g, "/")}`;


  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1
      }-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `SCVs Deployed Trips Reports`;
    const downloadDateTime = `Reported on: ${generationTimes}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 10);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    // Apply styles to the merged cells
    for (let col = 2; col <= 10; col++) {
      worksheet.getCell(1, col).font = boldFont;
      worksheet.getCell(1, col).alignment = { horizontal: "center" };
    }

    // Add the heading
    worksheet.addRow(["", "", "SCVs Deployed Trips Reports", ""]);
    worksheet.mergeCells(2, 2, 2, 10);
    worksheet.getCell(2, 2).value = `SCVs Deployed Trips Reports on ${fromDate ? formatDateTimeWithoutSec(fromDate) : getCurrentDateTime()} To ${toDate ? formatDateTimeWithoutSec(toDate) : getCurrentDateTime()} (at ${getCurrentDateTime1()})`;;
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    // Apply styles to the merged cells
    for (let col = 2; col <= 10; col++) {
      worksheet.getCell(2, col).font = boldFont;
      worksheet.getCell(2, col).alignment = { horizontal: "center" };
    }

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Zone",
      "Deployment",
      "Reported At TS/SCTP",
      "Total Trips",
      "Trip-1",
      "Trip-2",
      "Trip-3",
      "Trip-4",
      ">05 Trip",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left align the cell content
      if (colNumber >= 1 && colNumber <= 13) {
        // Apply background color only to specific cells
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
        };
      }
    });

    // Initialize totals
    let totalDeployment = 0;
    let totalReportedAtTS = 0;
    let totalTrips = 0;
    let totalOneTrip = 0;
    let totalTwoTrip = 0;
    let totalThreeTrip = 0;
    let totalFourTrip = 0;
    let totalMoreThanFiveTrip = 0;

    // Add data rows and accumulate totals
    zonesData.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.zoneName,
          item.deployment,
          item.reportedAtTS,
          item.totalTrips,
          item.oneTrip,
          item.twoTrip,
          item.threeTrip,
          item.fourTrip,
          item.moreThanFiveTrip,
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 13) {
            // Align the columns from 1 to 4 to the left
            cell.alignment = { horizontal: "left" };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = { horizontal: "left" };
          }
        });

      // Accumulate totals
      totalDeployment += item.deployment || 0;
      totalReportedAtTS += item.reportedAtTS || 0;
      totalTrips += item.totalTrips || 0;
      totalOneTrip += item.oneTrip || 0;
      totalTwoTrip += item.twoTrip || 0;
      totalThreeTrip += item.threeTrip || 0;
      totalFourTrip += item.fourTrip || 0;
      totalMoreThanFiveTrip += item.moreThanFiveTrip || 0;
    });

    // Add total row (without S.No)
    const totalRow = worksheet.addRow([
      "", // Leave S.No empty for the total row
      "Total", // The label for the total row
      totalDeployment,
      totalReportedAtTS,
      totalTrips,
      totalOneTrip,
      totalTwoTrip,
      totalThreeTrip,
      totalFourTrip,
      totalMoreThanFiveTrip,
    ]);

    totalRow.eachCell({ includeEmpty: true }, (cell) => {
      cell.font = boldFont; // Make total row bold
      cell.alignment = { horizontal: "left" }; // Center align the content
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "SCVsDeployedTripsReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  const calculateSCVTotals = (data) => {
    const totals = {
      sno: "",
      zoneName: "Total",
      deployment: 0,
      reportedAtTS: 0,
      totalTrips: 0,
      oneTrip: 0,
      twoTrip: 0,
      threeTrip: 0,
      fourTrip: 0,
      moreThanFiveTrip: 0,
    };

    data.forEach((row) => {
      totals.deployment += row.deployment || 0;
      totals.reportedAtTS += row.reportedAtTS || 0;
      totals.totalTrips += row.totalTrips || 0;
      totals.oneTrip += row.oneTrip || 0;
      totals.twoTrip += row.twoTrip || 0;
      totals.threeTrip += row.threeTrip || 0;
      totals.fourTrip += row.fourTrip || 0;
      totals.moreThanFiveTrip += row.moreThanFiveTrip || 0;
    });
    return totals;
  };

  const totalZoneRow = calculateSCVTotals(zonesData);
  const scvDataWithTotal = [...zonesData, totalZoneRow];

  const scvReportTripsColumns = [
    {
      name: "S.No",
      selector: (row) => row["sno"],
      //   sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
      width: "70px",
    },
    {
      name: "Zone",
      selector: (row) => row["zoneName"],
      // width:'9%',
      cell: (row) => <span>{row["zoneName"]}</span>,
      //    sortable: true,
      width: "120px",
    },
    {
      name: "Circle",
      // width:'9%',
      selector: (row) => row["circleName"],
      cell: (row) => <span>{row["circleName"]}</span>,
      //    sortable: true,
      width: "120px",
    },
    {
      name: <>Transfer Station</>,
      // width:'10%',
      selector: (row) => row["transferStationName"],
      cell: (row) => <span>{row["transferStationName"]}</span>,
      //   sortable: true,
      // width: "120px",
    },
    {
      name: (
        <>
          Reported At <br />
          TS/SCTP
        </>
      ),
      // width: "8%",
      selector: (row) => row["reportedAtTS"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleReportedAtTsTotalClick();
            } else {
              handleReportedAtTsClick(row);

            }
          }}
        >
          {row["reportedAtTS"]}
        </span>
      ),
      //    sortable: true,
      // width: "120px",
    },
    {
      name: "Total Trips",
      width: "8%",
      selector: (row) => row["totalTrips"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalTripsClickColumn();
            } else {
              handleTotalTripsClick(row);
            }
          }}
        >
          {row["totalTrips"]}
        </span>
      ),
      //    sortable: true,
      width: "120px",
    },
    {
      name: "Trip-1",
      width: "8%",
      selector: (row) => row["oneTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleOneSCVTripTotalClick();
            } else {
              handleOneSCVTripClick(row);
            }
          }}
        >
          {row["oneTrip"]}
        </span>
      ),
      //     sortable: true,
      width: "120px",
    },
    {
      name: "Trip-2",
      width: "8%",
      selector: (row) => row["twoTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTwoTripSCVTotalClick();
            } else {
              handleTwoSCVTripClick(row);
            }
          }}
        >
          {row["twoTrip"]}
        </span>
      ),
      //   sortable: true,
      width: "120px",
    },
    {
      name: "Trip-3",
      width: "8%",
      selector: (row) => row["threeTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleThreeTripTotalSCVClick();
            } else {
              handleThreeSCVTripClick(row);
            }
          }}
        >
          {row["threeTrip"]}
        </span>
      ),
      //     sortable: true,
      width: "120px",
    },
    {
      name: "Trip-4",
      width: "8%",
      selector: (row) => row["fourTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleFourTripSCVTotalClick();
            } else {
              handleFourSCVTripClick(row);
            }
          }}
        >
          {row["fourTrip"]}
        </span>
      ),
      //     sortable: true,
      width: "120px",
    },
    {
      name: ">05 Trip",
      width: "10%",
      selector: (row) => row["moreThanFiveTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleMoreThanFourSCVTripTotalClick();
            } else {
              handleMoreThanFourSCVTripClick(row);
            }
          }}
        >
          {row["moreThanFiveTrip"]}
        </span>
      ),
      //    sortable: true,
      width: "120px",
    },
  ];

  const handleOneSCVTripClick = async (row) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate1,
        EndDate: toDate1,
        TransferStationId: row.transferStationId,
        OwnerTypeId: selectedOwnerTypeTrips,
        VehicleTypeId: selectedCircleVehicleType,
        CircleId: row.circleId,
        TripTypeId: "1",
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/view-overall-trips", { state: {data:response.data,fromDate:fromDate1,toDate:toDate1}});
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleOneSCVTripTotalClick = async (row) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate1,
        EndDate: toDate1,
        OwnerTypeId: selectedOwnerTypeTrips,
        VehicleTypeId: selectedCircleVehicleType,
        // CircleId:row.circleId,
        TripTypeId: "1",
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/view-overall-trips", { state: {data:response.data,fromDate:fromDate1,toDate:toDate1} });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleTwoSCVTripClick = async (row) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate1,
        EndDate: toDate1,
        TransferStationId: row.transferStationId,
        OwnerTypeId: selectedOwnerTypeTrips,
        VehicleTypeId: selectedCircleVehicleType,
        CircleId: row.circleId,
        TripTypeId: "2",
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/view-overall-trips", { state: {data:response.data,fromDate:fromDate1,toDate:toDate1} });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleTwoTripSCVTotalClick = async (row) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate1,
        EndDate: toDate1,
        OwnerTypeId: selectedOwnerTypeTrips,
        VehicleTypeId: selectedCircleVehicleType,
        TripTypeId: "2",
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/view-overall-trips", { state: {data:response.data,fromDate:fromDate1,toDate:toDate1} });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleThreeSCVTripClick = async (row) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate1,
        EndDate: toDate1,
        TransferStationId: row.transferStationId,
        OwnerTypeId: selectedOwnerTypeTrips,
        VehicleTypeId: selectedCircleVehicleType,
        CircleId: row.circleId,
        TripTypeId: "3",
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/view-overall-trips", { state: {data:response.data,fromDate:fromDate1,toDate:toDate1} });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleThreeTripTotalSCVClick = async (row) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate1,
        EndDate: toDate1,
        OwnerTypeId: selectedOwnerTypeTrips,
        VehicleTypeId: selectedCircleVehicleType,
        // CircleId:row.circleId,
        TripTypeId: "3",
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/view-overall-trips", { state: {data:response.data,fromDate:fromDate1,toDate:toDate1} });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFourSCVTripClick = async (row) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate1,
        EndDate: toDate,
        TransferStationId: row.transferStationId,
        OwnerTypeId: selectedOwnerTypeTrips,
        VehicleTypeId: selectedCircleVehicleType,
        CircleId: row.circleId,
        TripTypeId: "4",
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/view-overall-trips", { state: {data:response.data,fromDate:fromDate1,toDate:toDate1} });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFourTripSCVTotalClick = async () => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate1,
        EndDate: toDate,
        OwnerTypeId: selectedOwnerTypeTrips,
        VehicleTypeId: selectedCircleVehicleType,
        TripTypeId: "4",
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/view-overall-trips", { state: {data:response.data,fromDate:fromDate1,toDate:toDate1} });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleMoreThanFourSCVTripClick = async (row) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate1,
        EndDate: toDate1,
        TransferStationId: row.transferStationId,
        OwnerTypeId: selectedOwnerTypeTrips,
        VehicleTypeId: selectedCircleVehicleType,
        CircleId: row.circleId,
        TripTypeId: "5",
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/view-overall-trips", { state: {data:response.data,fromDate:fromDate1,toDate:toDate1} });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleMoreThanFourSCVTripTotalClick = async () => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate1,
        EndDate: toDate1,
        OwnerTypeId: selectedOwnerTypeTrips,
        VehicleTypeId: selectedCircleVehicleType,
        TripTypeId: "5",
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/view-overall-trips", { state: {data:response.data,fromDate:fromDate1,toDate:toDate1} });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const exportToExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1
      }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `SCVs Overall Trips to TS/SCTP on ${fromDate1 ? formatDateTimeWithoutSec(fromDate1) : getCurrentDateTime()} To ${toDate1 ? formatDateTimeWithoutSec(toDate1) : getCurrentDateTime()}  (at ${getCurrentDateTime1()})`;
    const downloadDateTime = `Reported on: ${generationTimes}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the worksheet
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 10);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    // Add "SCVs Overall Trips Reports" to the worksheet
    worksheet.addRow(["", "", cumulativeHeadingReport, ""]);
    worksheet.mergeCells(2, 2, 2, 10);
    worksheet.getCell(2, 2).value = cumulativeHeadingReport;
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    // Add an empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Zone",
      "Circle",
      "Transferstation",
      // "Deployment",
      "Reported At TS/SCTP",
      "Total Trips",
      "Trip-1",
      "Trip-2",
      "Trip-3",
      "Trip-4",
      ">05 Trip",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left align the cell content
      if (colNumber >= 1 && colNumber <= 10) {
        // Apply background color to header cells
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
        };
      }
    });

    // Add data rows
    scvTripsData.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.zoneName ?? "N/A",
          item.circleName ?? "N/A",
          item.transferStationName ?? "N/A",
          // item.deployment ?? "N/A",
          item.reportedAtTS ?? "N/A",
          item.totalTrips ?? "N/A",
          item.oneTrip ?? "N/A",
          item.twoTrip ?? "N/A",
          item.threeTrip ?? "N/A",
          item.fourTrip ?? "N/A",
          item.moreThanFiveTrip ?? "N/A",
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 14) {
            // Align the columns from 1 to 10 to the left
            cell.alignment = { horizontal: "left" };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = { horizontal: "center" };
          }
        });
    });

    // Calculate the totals for the report
    const totalRow = calculateSCVOverallTotals(scvTripsData);

    // Add the total row (without S.No for total)
    worksheet.addRow([
      "", // Leave S.No empty for total row
      "",
      "",
      "Total", // Label the total row
      // totalRow.deployment,
      totalRow.reportedAtTS,
      totalRow.totalTrips,
      totalRow.oneTrip,
      totalRow.twoTrip,
      totalRow.threeTrip,
      totalRow.fourTrip,
      totalRow.moreThanFiveTrip,
    ]);

    // Style the total row (bold font, centered alignment)
    worksheet.lastRow.eachCell({ includeEmpty: true }, (cell) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Center align the total row
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 }, // S.No
      { width: 20 }, // Zone
      { width: 20 }, // Deployment
      { width: 20 }, // Zone
      { width: 20 }, // Deployment
      { width: 20 }, // Reported At TS/SCTP
      { width: 20 }, // Total Trips
      { width: 20 }, // Trip-1
      { width: 20 }, // Trip-2
      { width: 20 }, // Trip-3
      { width: 20 }, // Trip-4
      { width: 20 }, // >05 Trip
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "SCVsOverallTripsReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleReportedAtTsTotalClick = async () => {
    setIsOptionsLoading(true);
    try {
      // Call a different API for the total of the column
      const response = await AllTransferStationTotalTransactions(
        fromDate,
        toDate,
        "2",
        selectedOwnerTypeTrips, //ownerTypeId
        selectedCircleVehicleType,
        "",

      );

      navigate("/view-overall-trips", { state: response.data });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleReportedAtTsClick = async (row) => {
    console.log(row)
    try {
      setIsLoading(true);
      let response;
      const circleId = row.circleId ? row.circleId : ""; // Ensure it's always a valid string
      const zoneId = row.zoneId ? row.zoneId : ""; // Ensure it's always a valid string
      const transferStationId = row.transferStationId ? row.transferStationId : "";
      if (row.zoneId !== "" && row.circleId === "") {
        response = await AllTransferStationTransactions1(
          fromDate1, //start date
          toDate1, //end date
          "", //VehicleNumber
          zoneId, //zoneId,
          circleId, //circleId
          "2", //collectionTypeId
          selectedOwnerTypeTrips, //ownerTypeId
          selectedCircleVehicleType,
          row.transferStationId //transferStationId
        );
      }
      if (row.zoneId !== "" && row.circleId !== "") {
        response = await AllTransferStationTransactions1(
          fromDate1, //start date
          toDate1, //end date
          "", //VehicleNumber
          "", //zoneId,
          "", //circleId
          2, //collectionTypeId
          selectedOwnerTypeTrips, //ownerTypeId
          selectedCircleVehicleType,
          transferStationId //transferStationId
        );
      }
      navigate("/view-overall-trips", { state: {data:response.data,fromDate:fromDate1,toDate:toDate1} });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };


  const handleReportedAtTsZoneClick = async (row) => {
    try {
      setIsLoading(true);
      let response;
      const circleId = row.circleId ? row.circleId : ""; // Ensure it's always a valid string
      const zoneId = row.zoneId ? row.zoneId : ""; // Ensure it's always a valid string
      const transferStationId = row.transferStationId ? row.transferStationId : "";
      if (row.zoneId !== "" && row.circleId === "") {
        response = await AllTransferStationTransactions1(
          fromDate, //start date
          toDate, //end date
          "", //VehicleNumber
          zoneId, //zoneId,
          circleId, //circleId
          "2", //collectionTypeId
          selectedOwnerTypeTrips, //ownerTypeId
          selectedCircleVehicleType,
          row.transferStationId //transferStationId
        );
      }
      if (row.zoneId !== "" && row.circleId !== "") {
        response = await AllTransferStationTransactions1(
          fromDate, //start date
          toDate, //end date
          "", //VehicleNumber
          zoneId, //zoneId,
          "", //circleId
          "2", //collectionTypeId
          selectedOwnerTypeTrips, //ownerTypeId
          selectedCircleVehicleType,
          transferStationId //transferStationId
        );
      }
      navigate("/view-overall-trips",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleTotalTripsClickColumn = async () => {
    setIsOptionsLoading(true);
    try {
      const param = {
        StartDate: fromDate1,
        EndDate: toDate1,
        OwnerTypeId: selectedOwnerTypeTrips,
        VehicleTypeId: selectedCircleVehicleType,

      }
      const response = await GetSCVTripsToTS(param);
      navigate("/view-overall-trips", { state: {data:response.data,fromDate:fromDate1,toDate:toDate1} });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleTotalTripsClick = async (row) => {
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate1,
        EndDate: toDate1,
        TransferStationId: row.transferStationId,
        OwnerTypeId: selectedOwnerTypeTrips,
        VehicleTypeId: selectedCircleVehicleType,
        CircleId: row.circleId
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/view-overall-trips", { state: {data:response.data,fromDate:fromDate1,toDate:toDate1} });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const calculateSCVOverallTotals = (data) => {
    const totals = {
      sno: "Total",
      zoneName: "Total",
      deployment: 0,
      reportedAtTS: 0,
      totalTrips: 0,
      oneTrip: 0,
      twoTrip: 0,
      threeTrip: 0,
      fourTrip: 0,
      moreThanFiveTrip: 0,
    };

    data.forEach((row) => {
     
      totals.deployment += row.deployment || 0;
      totals.reportedAtTS += row.reportedAtTS || 0;
      console.log( totals.reportedAtTS )
      totals.totalTrips += row.totalTrips || 0;
      totals.oneTrip += row.oneTrip || 0;
      totals.twoTrip += row.twoTrip || 0;
      totals.threeTrip += row.threeTrip || 0;
      totals.fourTrip += row.fourTrip || 0;
      totals.moreThanFiveTrip += row.moreThanFiveTrip || 0;
    });
    return totals;
  };
  const totalOveraallRow = calculateSCVOverallTotals(scvTripsData);
  const scvOverallDataWithTotal = [...scvTripsData, totalOveraallRow];

  const fetchOverallData = async () => {
    try {
      setIsLoading(true);
      const response = await getAllOverallScvTrips(fromDate1, toDate1, selectedOwnerTypeTrips, selectedCircleVehicleType);
      setScvTripsData(response.data);
    } catch (error) {
      console.error("Error fetching overall SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchOverallData(); // Call the async function immediately
  }, []);

  const handleOverallSearch = () => {
    fetchOverallData(); // Call fetchData when the search button is clicked
  };
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 className="text-start mb-3">SCVs Trips to TS/SCTP</h4>
            <div className="row">
              <div className="col">
                <div className="">
                  <div className="row mb-5">
                    <div className="col-xl-12 col-md-12">
                      <div className="card">
                        <div className="card-body">
                          <Tabs
                            selectedIndex={selectedTab}
                            onSelect={handleTabSelect}
                          >
                            <TabList style={{ display: "flex" }}>
                              <Tab
                                className={`datatable_tabs ${isProd
                                  ? selectedTab === 0
                                    ? "active-ghmc"
                                    : "active-swm"
                                  : selectedTab === 0
                                    ? "active-default"
                                    : "inactive-default"
                                  }`}
                              >
                                SCVs Deployed Trips to TS/SCTP
                              </Tab>
                              <Tab
                                className={`datatable_tabs ${isProd
                                  ? selectedTab === 1
                                    ? "active-ghmc"
                                    : "active-swm"
                                  : selectedTab === 1
                                    ? "active-default"
                                    : "inactive-default"
                                  }`}
                              >
                                SCVs Overall Trips to TS/SCTP
                              </Tab>
                            </TabList>
                            <TabPanel>
                              <div className="row align-items-center  mt-3">
                                <div className="col-md-12">
                                  <div className="row text-start">
                                    <div className="col-md-2">
                                      <label htmlFor="fromDate">
                                        From Date & Time:
                                      </label>
                                      <input
                                        type="datetime-local"
                                        id="fromDate"
                                        style={inputStyle}
                                        className="form-control"
                                        value={fromDate}
                                        max={
                                          toDate ? toDate : getCurrentDateTime()
                                        }
                                        onChange={(e) => {
                                          setFromDate(e.target.value);
                                          localStorage.setItem(
                                            "DeployedFromDate",
                                            e.target.value
                                          );
                                        }}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      <label htmlFor="toDate">
                                        To Date & Time:
                                      </label>
                                      <input
                                        type="datetime-local"
                                        id="toDate"
                                        className="form-control"
                                        style={inputStyle}
                                        value={toDate}
                                        min={fromDate}
                                        // max={getCurrentDateTime()}
                                        onChange={(e) => {
                                          setToDate(e.target.value);
                                          localStorage.setItem(
                                            "DeployedToDate",
                                            e.target.value
                                          );
                                        }}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      <label htmlFor="VehicleTypeId">Vehicle Type</label>
                                      <select
                                        className="form-select"
                                        // style={{ backgroundColor: "#fff" }}
                                        name="vehicleTypeId"
                                        value={selectedVehicleType}
                                        // id="vehicleTypeId"
                                        // onChange={(e) => setVehicleTypeId(e.target.value)}
                                        style={inputStyle2}
                                        // name="vehicleTypeId"
                                        id="vehicleType"
                                        // value={selectedOwnerType}
                                        onChange={(e) => {
                                          setSelectedVehicleType(e.target.value);
                                          localStorage.setItem(
                                            "vehicleType",
                                            e.target.value
                                          );
                                        }}
                                      >
                                        <option value="">All</option>
                                        {vehicleTypeDetails
                                          .filter((vehicle) => vehicle.isActive)
                                          .map((vehicle) => (
                                            <option
                                              key={vehicle.vehicleTypeId}
                                              value={vehicle.vehicleTypeId}
                                            >
                                              {vehicle.vehicleTypeName}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                    <div className="col-md-2">
                                      <label htmlFor="Owner type">
                                        Owner Type
                                      </label>
                                      <select
                                        className="form-select"
                                        style={inputStyle2}
                                        name="ownerTypeId"
                                        id="ownerType"
                                        value={selectedOwnerType}
                                        onChange={(e) => {
                                          setSelectedOwnerType(e.target.value);
                                          localStorage.setItem(
                                            "DeployedOwnerType",
                                            e.target.value
                                          );
                                        }}
                                      >
                                        <option value="">All</option>
                                        {ownerTypeDetails
                                          .filter((ownerType) => ownerType.isActive)
                                          .map((ownerType) => (
                                            <option
                                              key={ownerType.ownerTypeId}
                                              value={ownerType.ownerTypeId}
                                            >
                                              {ownerType.ownerTypeName}
                                            </option>
                                          ))}
                                      </select>
                                    </div>

                                    <div className="col-md-4 d-flex">
                                      <button
                                        className={`btn mr-2 ${isProd ? "search-ghmc" : "search-swm"
                                          }`}
                                        onClick={handleSearch}
                                      >
                                        Search
                                      </button>
                                      <button
                                        className={`btn ${isProd ? "search-ghmc" : "search-swm"
                                          }`}
                                        onClick={() => {
                                          localStorage.setItem("DeployedFromDate", getStartOfCurrentDate());
                                          localStorage.setItem("DeployedToDate", getCurrentDateTime());
                                          localStorage.setItem("vehicleType", "");
                                          localStorage.setItem("DeployedOwnerType", "");
                                          setFromDate(getStartOfCurrentDate());
                                          setToDate(getCurrentDateTime());
                                          setSelectedOwnerType("");
                                          setSelectedVehicleType("")
                                        }}
                                      >
                                        Reset
                                      </button>
                                      <button
                                        className="btn btn-excel ms-auto"
                                        onClick={downloadAsExcel}
                                      >
                                        <i className="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                                        Excel
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="card mt-3">
                                <div className="">
                                  <div className="top-header">
                                    <span> SCVs Deployed Trips TS/SCTP
                                      ({fromDate ? formatDateTimeWithoutSec(fromDate) : getCurrentDateTime()} To {toDate ? formatDateTimeWithoutSec(toDate) : getCurrentDateTime()}) (at {getCurrentDateTime1()})
                                    </span>
                                  </div>
                                  <CustomDataTable
                                    data={scvDataWithTotal}
                                    columns={scvReportColumns}

                                  // headers={headers}
                                  // link={true}
                                  // search={true}
                                  // fromDate={fromDate}
                                  // toDate={toDate}
                                  />
                                </div>
                              </div>
                            </TabPanel>
                            <TabPanel>
                              <div className="row justify-content-between align-items-center  mt-3">
                                <div className="col-md-12">
                                  <div className="row text-start">
                                    <div className="col-md-2">
                                      <label
                                        htmlFor="fromDate"
                                      >
                                        From Date & Time:
                                      </label>
                                      <input
                                        type="datetime-local"
                                        name="fromDate1"
                                        style={inputStyle}
                                        className="form-control"
                                        value={fromDate1}
                                        max={
                                          toDate ? toDate : getCurrentDateTime()
                                        }
                                        onChange={(e) => {
                                          setFromDate1(e.target.value);
                                          localStorage.setItem(
                                            "DeployedFromDate1",
                                            e.target.value
                                          );
                                        }}
                                      />
                                    </div>

                                    <div className="col-md-2">
                                      <label
                                        htmlFor="toDate"
                                      >
                                        To Date & Time:
                                      </label>
                                      <input
                                        type="datetime-local"
                                        name="toDate"
                                        className="form-control"
                                        style={inputStyle}
                                        value={toDate1}
                                        min={fromDate1}
                                        // max={getCurrentDateTime()}
                                        onChange={(e) => {
                                          setToDate1(e.target.value);
                                          localStorage.setItem(
                                            "DeployedToDate1",
                                            e.target.value
                                          );
                                        }}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      <label htmlFor="VehicleTypeId">Vehicle Type</label>
                                      <select
                                        className="form-select"
                                        // style={{ backgroundColor: "#fff" }}
                                        name="circleVehicleTypeId"
                                        value={selectedCircleVehicleType}
                                        // id="vehicleTypeId"
                                        // onChange={(e) => setVehicleTypeId(e.target.value)}
                                        style={inputStyle2}
                                        // name="vehicleTypeId"
                                        id="circleVehicleType"
                                        // value={selectedOwnerType}
                                        onChange={(e) => {
                                          setSelectedCircleVehicleType(e.target.value);
                                          localStorage.setItem(
                                            "circleVehicleType",
                                            e.target.value
                                          );
                                        }}
                                      >
                                        <option value="">All</option>
                                        {vehicleTypeDetails
                                          .filter((vehicle) => vehicle.isActive)
                                          .map((vehicle) => (
                                            <option
                                              key={vehicle.vehicleTypeId}
                                              value={vehicle.vehicleTypeId}
                                            >
                                              {vehicle.vehicleTypeName}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                    <div className="col-md-2">
                                      <label
                                        htmlFor="Owner type"
                                      >
                                        Owner Type
                                      </label>
                                      <select
                                        className="form-select"
                                        style={inputStyle2}
                                        name="ownerTypeId"
                                        id="ownerType"
                                        value={selectedOwnerTypeTrips}
                                        onChange={(e) => {
                                          setSelectedOwnerTypeTrips(
                                            e.target.value
                                          );
                                          localStorage.setItem(
                                            "OverallOwnerType ",
                                            e.target.value
                                          );
                                        }}
                                      >
                                        <option value="">All</option>
                                        {ownerTypeDetailsTrips
                                          .filter((ownerType) => ownerType.isActive)
                                          .map(
                                            (ownerType) => (
                                              <option
                                                key={ownerType.ownerTypeId}
                                                value={ownerType.ownerTypeId}
                                              >
                                                {ownerType.ownerTypeName}
                                              </option>
                                            )
                                          )}
                                      </select>
                                    </div>
                                    <div className="col-md-4 d-flex">
                                      <button
                                        className={`btn mr-2 ${isProd ? "search-ghmc" : "search-swm"
                                          }`}
                                        onClick={handleOverallSearch}
                                      >
                                        Search
                                      </button>
                                      <button
                                        className={`btn  ${isProd ? "search-ghmc" : "search-swm"
                                          }`}
                                        onClick={() => {
                                          localStorage.removeItem(
                                            "DeployedFromDate1"
                                          );
                                          localStorage.removeItem(
                                            "DeployedToDate1"
                                          );
                                          localStorage.removeItem(
                                            "OverallOwnerType"
                                          );
                                          localStorage.removeItem(
                                            "circleVehicleType"
                                          );

                                          setFromDate1(getStartOfCurrentDate());
                                          setToDate1(getCurrentDateTime());
                                          setSelectedOwnerTypeTrips("");
                                          setSelectedCircleVehicleType("")
                                        }}
                                      >
                                        Reset
                                      </button>
                                      <button
                                        className="btn btn-excel ms-auto"
                                        onClick={exportToExcel}
                                      >
                                        <i className="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                                        Excel
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="card mt-3">
                                <div className="top-header">
                                  <span> SCVs Overall Trips to TS/SCTP  
                                    ({fromDate1 ? formatDateTimeWithoutSec(fromDate1) : getCurrentDateTime()} To {toDate1 ? formatDateTimeWithoutSec(toDate1) : getCurrentDateTime()})  (at {getCurrentDateTime1()})</span>
                                </div>
                                <CustomDataTable
                                  data={scvOverallDataWithTotal}
                                  columns={scvReportTripsColumns}
                                  dataPerPage={dataPerPage}
                                />
                              </div>
                            </TabPanel>
                          </Tabs>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
    </>
  );
};
// Function to get default date in "YYYY-MM-DDTHH:MM" format
const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};
// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};

export default SCVReports;

const inputStyle = {
  backgroundColor: "#fff",
  height: "38px",
  border: "1px solid #E2E2E2",
  padding: "15px",
  borderRadius: "0px",
};

const inputStyle2 = {
  backgroundColor: "#fff",
  height: "38px",
  border: "1px solid #E2E2E2",
  // padding: "15px",
  borderRadius: "0px",
};
